/**
 * Asset model parser and slave ID calculator
 * Parses carProfile.model strings like "2DEYE2GCE9M" or "DALYLV"
 */

export const BATTERY_TYPE = {
  GCE: 'GCE',
  DALYLV: 'DALYLV',
};

// DALY low-voltage standalone BMS request slave address (observed in live frame 81030000007F1BEA)
export const DALY_SLAVE_ID = 0x81; // 129

/**
 * Parse asset model string to extract counts and battery type
 * @param {string} model - Asset model (e.g., "2DEYE2GCE9M" or "DALYLV")
 * @returns {object} { type, invCount, batCount, modCount }
 */
export function parseAssetModel(model) {
  const s = (model || '').trim();
  if (/^DALYLV$/i.test(s)) {
    return { type: BATTERY_TYPE.DALYLV, invCount: 0, batCount: 1, modCount: 0 };
  }
  const m = s.match(/^(\d+)DEYE(\d+)GCE(\d+)M$/i);
  if (!m) return { type: BATTERY_TYPE.GCE, invCount: 1, batCount: 1, modCount: 9 };
  return {
    type: BATTERY_TYPE.GCE,
    invCount: parseInt(m[1], 10),
    batCount: parseInt(m[2], 10),
    modCount: parseInt(m[3], 10),
  };
}

/**
 * Get battery slave IDs based on asset config
 * @param {object} config - { invCount, batCount, modCount, type }
 * @returns {array} Array of slave IDs for batteries
 *
 * Example: invCount=2, batCount=2 → [3, 4]
 * Example: type='DALYLV' → [129]
 */
export function getBatterySlaveIds(config) {
  if (config && config.type === BATTERY_TYPE.DALYLV) {
    return [DALY_SLAVE_ID];
  }
  const { invCount = 0, batCount = 0 } = config || {};
  const ids = [];
  for (let i = 1; i <= batCount; i++) {
    ids.push(invCount + i);
  }
  return ids;
}

/**
 * Convert slave ID to 2-char hex prefix for matching rs485modbus keys
 * @param {number} slaveId - Slave address (e.g., 3, 129)
 * @returns {string} Hex prefix (e.g., "03", "81")
 */
export function slaveIdToHexPrefix(slaveId) {
  return slaveId.toString(16).padStart(2, '0').toUpperCase();
}

